export const WAITLIST_EMAIL_INPUT_ID = "waitlist-email";
